import { render } from "./ExportAbraWork.vue?vue&type=template&id=a927234a&ts=true"
import script from "./ExportAbraWork.vue?vue&type=script&lang=ts"
export * from "./ExportAbraWork.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__